// import React, { useEffect } from "react";
// import { Auth } from "aws-amplify";
// import { useNavigate, useLocation } from "react-router-dom";

// const UserSession = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   useEffect(() => {
    
//     const checkUserSession = async () => {
//       try {
//         const currentSession = await Auth.currentSession().then((session) => {

//           if (location.pathname === "/") {
//             navigate("./site-explorer");
//           } else if (
//             location.pathname === "/site-explorer" ||
//             location.pathname === "/site-explorer/"
//           ) {
            
//             navigate("./");
//           }
//           //  Check if the access token is expired
//           const accessToken = session.getAccessToken();

//           const expirationTime = new Date(accessToken.payload.exp * 1000);

//           const currentTime = new Date();

//           if (expirationTime < currentTime) {
//             console.log("Access token expired, refreshing session...");

//             // Refresh the session using the refresh token
//             const refreshedSession = Auth.refreshSession(
//               currentSession.refreshToken
//             );

            
//           }
//         });
//       } catch (error) {
//         console.log(error);
//         if (error == "No current user") {
//           console.log(error);
//           navigate("/");
//         }
//       }
//     };
//     checkUserSession();
//   }, []);

//   return <></>;
// };

// export default UserSession;



import React, { useEffect, useContext, useState } from "react";
import { Auth } from "aws-amplify";
import { useNavigate, useLocation } from "react-router-dom";
import { RootContext } from "../../contexts/root-context";
import axios from "axios";
import { BEDAS_BASE_URL } from "../../strings";
import { getToken } from "./get-token";
import { decryptData } from "../../util";

const UserSession = () => {

    const navigate = useNavigate();
    const location = useLocation()
    const { authDetails, setauthDetails } = useContext(RootContext);


    const reloadPage = async () => {

        let username = decryptData(localStorage.getItem("logged_in_user"));

        try {
            const response = await axios.get(
                BEDAS_BASE_URL + `rbac-get?id=` + username.trim(), getToken()
            );
            let userInfo = response.data;

            setauthDetails([{ ...authDetails, userInfo: userInfo }]);
            localStorage.setItem("USER_INFO", JSON.stringify(userInfo));

        } catch (error) {

        }
        //  }
        window.location.reload();
    }
    useEffect(() => {

        checkUserSession()
    }, []);

    const checkUserSession = async () => {

        try {
            const currentSession = await Auth.currentSession()
                .then(session => {
                    // 

                    if (location.pathname === "/") {
                        reloadPage();
                        navigate("./substation-explorer");

                    }
                    //  Check if the access token is expired
                    const accessToken = session.getAccessToken();

                    const expirationTime = new Date(accessToken.payload.exp * 1000);

                    const currentTime = new Date();

                    if (expirationTime < currentTime) {


                        // Refresh the session using the refresh token
                        const refreshedSession = Auth.refreshSession(
                            currentSession.refreshToken
                        );


                    }
                })


        } catch (error) {

            // 
            if (error == "No current user") {


                navigate("/");
                //   reloadPage();
            }
        } finally {

        }
    };
    checkUserSession();


    return (<></>)
};

export default UserSession;
